import "../../src/assets/styles/Header.css";
import logo from "../imgs/f8bet/logo.png";
import iconBack from "../imgs/f8bet/icon-back.png";
import { useNavigate } from "react-router-dom";
function Header({ isPageSearch, webSetting }) {
  const navigate = useNavigate();
  const handleBack = () => {
    if (isPageSearch) {
      window.location.href = webSetting?.link_home ?? "https://f8beta2.com";
    } else {
      navigate("/");
    }
  };

  return (
    <div>
      <div className="status-bar"></div>
      <div className="header">
        {/* Button BACK luôn hiển thị ở góc trên cùng bên trái */}
        <button
          className="btn-back-fixed"
          onClick={handleBack}
          aria-label="Quay lại"
        >
          <img src={iconBack} alt="icon-back" />
        </button>
        <div className="header-logo">
          <div className="main-logo">
            <img src={logo} alt="logo"></img>
          </div>
        </div>
        <p>HỖ TRỢ KHÁCH HÀNG</p>
      </div>
    </div>
  );
}

export default Header;
